import { useEffect, useRef, useState } from 'react'
import { motion } from 'framer-motion'

import Captcha from 'captcha-image'
import reload from '../Imgs/svg/ReLoad.svg'

function CaptchaGenerator({ setCaptchaCheck }) {
  const [data, setData] = useState({ image: null })
  const [captcha, setCaptcha] = useState('')
  const [pass, setPass] = useState(false)
  const [inputModified, setInputModified] = useState(false)

  const inputRef = useRef(null) // sirve para vaciar el input texto cuando se recarga

  const { image } = data

  const checkCaptcha = (event) => {
    const currentValue = event.target.value
    if (currentValue === captcha) {
      setPass(true)
      setCaptchaCheck(true)
    } else {
      setPass(false)
      setCaptchaCheck(false)
    }
    setInputModified(true) // Da estilos si el Captcha esta incorrecto
  }

  const handleClick = () => {
    // event.preventDefault();
    const captchaImage = new Captcha(
      '29px Courier',
      'center',
      'middle',
      140,
      50,
      'white',
      'black',
      5
    ).createImage()

    const dataKey = extractDataKey(captchaImage)

    setCaptcha(dataKey)

    setData({ ...data, image: captchaImage })
    setInputModified(false)

    inputRef.current.value = ''
  }

  function extractDataKey(captchaImage) {
    const regex = /data-key="([^"]+)"/
    const match = captchaImage.match(regex)

    if (match && match.length >= 2) {
      return match[1]
    }

    return null
  }

  const createMarkup = (source) => {
    return { __html: source }
  }

  const MyCaptcha = () => {
    return <div dangerouslySetInnerHTML={createMarkup(image)} />
  }

  useEffect(() => {
    handleClick()
  }, [])

  // ...

  return (
    <div className="flex flex-col lg:flex-row w-full">
      <div className="rounded-lg w-full">
        <input
          placeholder="Ingresa el texto mostrado"
          className="p-4 bg-gray-100 rounded mb-5 w-full border-none"
          onChange={checkCaptcha}
          type="text"
          ref={inputRef}
        />
      </div>
      <div className="flex h-[25px] mt-[20px] mr-5 items-center">
        <div
          className={`h-[60px] ${
            inputModified && !pass ? 'border-Main' : ''
          } rounded-lg flex items-center ml-2`}
        >
          <MyCaptcha />
        </div>
        <div className="flex-col">
          <motion.img
            className="cursor-pointer ml-5"
            onClick={handleClick}
            src={reload}
            alt="reload"
            whileHover={{ scale: 1.2 }}
            whileTap={{ scale: 0.8, rotate: 360 }}
          />
          <small>Reiniciar</small>
        </div>
      </div>
    </div>
  )
}

export default CaptchaGenerator
